var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_258",
    "data-name": "Component 258",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2883",
    "data-name": "Rectangle 2883",
    width: 30,
    height: 30,
    transform: "translate(307 59)",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_185",
    "data-name": "Mask Group 185",
    transform: "translate(-307 -59)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11379",
    "data-name": "Group 11379",
    transform: "translate(312 61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7808",
    "data-name": "Path 7808",
    d: "M20,1.689V15.723A21.232,21.232,0,0,1,10,26C5.565,23.512,2.1,20.569,0,15.716V1.682a30.508,30.508,0,0,1,20,.007ZM1.213,2.607V15.458c1.832,4.14,5,6.946,8.791,9.123a19.828,19.828,0,0,0,8.783-9.13V2.6a29.176,29.176,0,0,0-17.574.006Z",
    transform: "translate(0 0)",
    fill: "current"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlans);
export default __webpack_public_path__ + "static/media/plans.a80b9a3e5e7b4e3484db257082c34082.svg";
export { ForwardRef as ReactComponent };